export const getFullURL = (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  return a.href;
}

export const serialize = function (obj: Record<string, any>, prefix?: string): string {
  var str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}

export const createGetURL = (url: string, params?: Record<string, any>) => {
  const fullUrl = new URL(getFullURL(url));
  if (params) fullUrl.search += (fullUrl.search !== '' ? '&' : '') + serialize(params);
  return fullUrl.toString();
}